// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"9f5eec42","239":"139eae20","455":"2cfddee5","584":"66da7a79","644":"0927bd81"}[chunkId] + ".chunk.js";
};